import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BoardData } from './board.model';

// TVG-111: Aggregated sales Kanban board data.
@Injectable({ providedIn: 'root' })
export class BoardService {
  private readonly url = `${environment.apiUrl}/api/board`;

  constructor(private http: HttpClient) {}

  getBoard(
    venueIds: number[] = [],
    // TVG-124: Lost-column scope filter — 'this-quarter' (default) or 'all'.
    lostFilter: 'this-quarter' | 'all' = 'this-quarter',
    // TVG-123: Cancelled-column scope filter — 'this-year' (default) or 'all'.
    cancelledFilter: 'this-year' | 'all' = 'this-year',
  ): Observable<BoardData> {
    let params = new HttpParams();
    if (venueIds.length > 0) {
      venueIds.forEach((id) => {
        params = params.append('venue_ids[]', id.toString());
      });
    }
    params = params.set('lost_filter', lostFilter);
    params = params.set('cancelled_filter', cancelledFilter);
    return this.http
      .get<{ data: BoardData }>(this.url, { params })
      .pipe(map((res) => res.data));
  }

  // TVG-117: count of draft quotes that landed since the user's last Sales
  // board view, for the sidebar nav badge.
  getNewQuotesCount(): Observable<number> {
    return this.http
      .get<{ data: { count: number } }>(`${this.url}/new-quotes-count`)
      .pipe(map((res) => res.data?.count ?? 0));
  }

  // TVG-117: stamp the user's last_sales_board_viewed_at to now, clearing
  // the sidebar nav badge.
  markViewed(): Observable<void> {
    return this.http
      .post<{ data: { count: number } }>(`${this.url}/mark-viewed`, {})
      .pipe(map(() => undefined));
  }
}
